import { createContext } from "react";

export const GetSectionIndex = createContext({});
